const {h, render, Component} = require('preact');


class Click2CallSubmitView extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <input class="submit-button-click-to-call btn" disabled
                   data-bhw="create-ticket_" type="button" onClick={this.props.onSubmitClick} value={I18n.translate('js.modules.support.call_me_back_btn_text')} data-bhw="web_2018_callback_create_ticket"/>
        )
    }
}

module.exports = Click2CallSubmitView
